import { render, staticRenderFns } from "./ForcedDisconnect.vue?vue&type=template&id=1b077bcf&scoped=true&"
import script from "./ForcedDisconnect.vue?vue&type=script&lang=js&"
export * from "./ForcedDisconnect.vue?vue&type=script&lang=js&"
import style0 from "./ForcedDisconnect.vue?vue&type=style&index=0&id=1b077bcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b077bcf",
  null
  
)

export default component.exports